<template>
  <div class="evaluation-sum">
    <div class="write-message">
      <div class="write-line">
        <div class="user-content">
          <span class="write-name mr-2">{{ userName }}</span>
          <span v-show="rating.purchaseVerify"
                class="badge badge-success font-normal font-weight-normal">
            STR 驗證購買
          </span>
        </div>
        <div class="btn-group" v-show="thumbsUpShow">
            <button type="button" class="btn btn-outline-secondary"
                    :class="{ deactivate:!authCheck, pick:like}"
                    @click="toggleLike('like')">
              <img src="img/pic/thumbs_up.svg" class="bi bi-hand-thumbs-up" alt="">
              <span class="point-number" v-text="likeCount"></span>
            </button>
            <button type="button" class="btn btn-outline-secondary"
                    :class="{ deactivate:!authCheck, pick:dislike}"
                    @click="toggleLike('dislike')">
              <img src="img/pic/thumbs_down.svg" class="bi bi-hand-thumbs-down" alt="">
              <span class="point-number visually-hidden" v-text="dislikeCount"></span>
            </button>
          </div>
        <div v-for="(item, key) in [1, 2, 3, 4, 5]" :key="key"
             class="write-icon" :class="{active : rating.rating >= item }"></div>
      </div>
      <div class="write-info">
        <div class="write-pic">
          <img :src="userPicUrl || 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg'" alt="">
        </div>
        <p class="write-depiction" v-text="rating.content">
        </p>
      </div>
      <div class="rating-carousel owl-carousel popup-gallery">
        <div v-for="(pic, key) in rating.Pics" :key="key" class="gallery-item">
          <a :href="pic.url['w0h0']" data-effect="mfp-zoom-in" title="">
            <img :src="pic.url['w0h0']" @error="handleImageError" alt="">
          </a>
        </div>
      </div>
      <div class="write-footer">
        <div class="replyTime" data-toggle="tooltip" data-placement="top" :title="rating.createdAt" v-html="timeAgo(rating.createdAt)"></div>
        <div v-show="userCheckPurview && !rating.Replies[0]" :data-id="ratingId" class="reply-btn" @click="toggleReply">回覆</div>
      </div>
    </div>
    <div v-for="reply in rating.Replies" class="evaluation-lecturer">
      <div class="write-info">
        <div class="replyName">
        </div>
        <div class="write-pic">
          <img
              :src="replyPicUrl || 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg'" title="" alt="">
        </div>
        <p class="write-depiction" v-text="reply.content"></p>
      </div>
      <div class="rating-carousel owl-carousel popup-gallery">
        <div v-for="(pic, key) in reply.Pics" :key="key" class="gallery-item">
          <a :href="pic.url['w0h0']" data-effect="mfp-zoom-in" title="">
            <img :src="pic.url['w0h0']" @error="handleImageError" alt="">
          </a>
        </div>
      </div>
      <div class="write-footer">
        <div class="replyTime" data-toggle="tooltip" data-placement="top" :title="reply.createdAt" v-text="timeAgo(reply.createdAt)"></div>
      </div>
    </div>
<!-- 回覆框 -->
    <div v-if="!rating.Replies[0]" :id="'reply-form-'+ratingId"
         class="evaluation-lecturer reply-form">
      <div class="evaluation-pic">
        <img :src="replyPicUrl || 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg'" title="" alt="">
      </div>
      <form :action="ratingPostUrl" method="post">
        <div class="rating-reply">
          <textarea name="ratingReply"></textarea>
          <inputUploadPic
              :inputName="'picIds'"
              :postMaxSize="postMaxSize"
              :uploadMaxSize="uploadMaxSize"
              :maxFileUploads="maxFileUploads"
          ></inputUploadPic>
          <button class="rating-reply-btn" type="submit">回覆評價</button>
        </div>
        <input type="hidden" name="ratingId"
               :value="ratingId">
        <input type="hidden" name="pageSlug"
               :value="pageSlug">
      </form>
    </div>
  </div>
</template>


<script>

import InputUploadPic from 'FF/Vue/ControlCenter/CustomComponent/EditControlCenter/LineContent/Base/InputUploadPic.vue';
import moment from 'moment';
import 'magnific-popup';
import 'magnific-popup/src/css/main.scss';

export default {
  components: {
    InputUploadPic,
  },
  props: {
    currentUserId: {
      type: Number,
      default: -1,
    },
    userName: {
      type: String,
      default: '',
    },
    userPicUrl: {
      type: String,
      default: '',
    },
    replyPicUrl: {
      type: String,
      default: '',
    },
    thumbsUpShow: {
      type: Boolean,
      default: true,
    },
    rating: {
      type: Object,
      default: () => ({}),
    },
    authCheck: {
      type: Boolean,
      default: false,
    },
    userCheckPurview: {
      type: Boolean,
      default: false,
    },
    postMaxSize: {
      type: Number,
      default: 0,
    },
    uploadMaxSize: {
      type: Number,
      default: 0,
    },
    maxFileUploads: {
      type: Number,
      default: 0,
    },
    hiddenDislikeRattingCount: {
      type: Number,
      default: 0,
    },
    pageSlug: {
      type: String,
      default: '',
    },
    likePostUrl: {
      type: String,
      default: null,
    },
    ratingPostUrl:{
      type: String,
      default: '',
    }
  },
  data() {
    return {
      likeCount: 0,
      dislikeCount: 0,
      ratingId: 0,
      like: false,
      dislike: false,
    };
  },
  computed: {},
  watch: {
  },
  mounted() {
    this.init();
  },
  updated(){
    this.refreshPlugin();
  },
  methods: {
    init() {
      if (Array.isArray(this.rating?.Eavs) && this.rating.Eavs.length > 0) {
        this.likeCount = this.rating.Eavs[0]?.value?.like?.count || 0;
        this.dislikeCount = this.rating.Eavs[0]?.value?.dislike?.count || 0;
      } else {
        this.likeCount = 0;
        this.dislikeCount = 0;
      }

      this.ratingId = this.rating.id;

      this.like = this.checkThumbs('like');
      this.dislike = this.checkThumbs('dislike');
      this.refreshPlugin();

    },
    refreshPlugin() {
      $('[data-toggle="tooltip"]').tooltip();
      $('.rating-carousel').each((key, value) => {

        $(value).owlCarousel({
          autoplay: false, // 自動撥放
          loop: false, // 圖片循環
          center: false, // 是否置中
          navText: [], // 箭頭預設文字消失
          nav: false, // 前後箭頭
          dot: true,
          margin: 10,
          stagePadding: 30,
          responsive: {
            0: {
              items: 1,
            },
            480: {
              items: 2,
            },
            768: {
              items: 3,
            },
            1024: {
              items: 4,
              margin: 20,
            },
          },
        });
        $(value).magnificPopup({
          delegate: '.owl-item:not(.cloned) a',
          type: 'image',
          removalDelay: 100, // delay removal by X to allow out-animation
          gallery: {
            enabled: true,
          },
        });
        /* bug 導致 dots 被關閉*/
        $(value).find('.owl-dots').removeClass('disabled');
        $(value).trigger('refresh.owl.carousel');
      });
    },
    handleImageError(event) {
      event.target.src = 'img/pic/no_image_icon.png';
    },
    showRating(){
      /* 設定未開啟, 或者 發文者本身 顯示該評論*/
      if(this.hiddenDislikeRattingCount === 0 || this.rating.userId == this.currentUserId){
        return true;
      }

      /* 不喜歡 大於 設定數, 隱藏該評論*/
      if(this.dislikeCount >= this.hiddenDislikeRattingCount){
        return false;
      }

      return true;
    },
    checkThumbs(type) {
      if (!this.rating || !this.rating.Eavs || !this.rating.Eavs[0] || !this.rating.Eavs[0].value || !(type in this.rating.Eavs[0].value)) {
        return false;
      }

      const userIds = this.rating.Eavs[0].value[type].userIds;
      const isActive = Array.isArray(userIds) && userIds.includes(this.currentUserId);
      return isActive;
    },
    toggleLike(type) {
      if (this.authCheck) {
        const hasPick = this[type];
        const revertType = type === 'like' ? 'dislike' : 'like';

        /* 只要點擊 必定相反value */
        this[type] = !this[type];

        /* 如果有點擊 則-1 */
        if (hasPick) {
          this[`${type}Count`] -= 1;
        } else {
          this[`${type}Count`] += 1;
        }

        /* 反向action判斷是否需要 revert */
        if (this[revertType]) {
          this[`${revertType}Count`] -= 1;
          this[revertType] = !this[revertType];
        }
        this.postLikeCount(type);
      }
    },
    postLikeCount(type){
      axios.post(this.likePostUrl,
          {
            userId: this.currentUserId,
            ratingId: this.ratingId,
            type,
          })
          .catch((e) => {
            console.warn(e);
          });
    },
    toggleReply(event) {
      let id = $(event.currentTarget).attr('data-id');
      $('#reply-form-' + id).toggleClass('rating-reply-open');
    },
    timeAgo(dateTime) {
      return moment(dateTime).locale('zh-tw').fromNow();
    },
  },
};
</script>
<style scoped lang="scss">
  .rating-reply{
    padding: 0rem 2rem;
  }

  .rating-reply-open {
    .evaluation-pic{
      margin-left: 1rem;
    }
  }

  .write-message{
    padding-bottom: 1rem;
  }

  .evaluation-lecturer{
    padding: 1.5rem 0rem 1rem 1rem;
  }

  .replyTime {
    display: inline-block;
    color: #9f9f9f;
    font-size: 12px;
  }
  .replyName {
    margin-bottom: 8px;
  }
  .write-footer{
    font-size: 14px;
    text-align: right;
    color: #666;
    padding: 7px 20px 0px;
    //border-top: 1px solid #ccc;
    .reply-btn{
      margin-left: 15px;
      display: inline-block;
      cursor: pointer;
    }
  }

  .owl-carousel .owl-item img {
    width: 100%; /* 或者你可以指定具体的宽度，如 300px */
    height: 120px; /* 或者你可以指定具体的高度 */
    object-fit: contain; /* 如果你希望图片能覆盖整个区域并保持宽高比，可以使用这个属性 */
  }

  .bi.bi-hand-thumbs-up, .bi.bi-hand-thumbs-down{
    width: 16px;
    height: 16px;
    opacity: 0.7;
  }

</style>
